import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IDataUser, ILoginEmployee } from '../interfaces/ILoginEmployee';
import { IChallengeQuestionsReq } from '../interfaces/IChallengeQuestions';
import { environment } from 'src/environments/environment';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { tap } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private apiUrl = environment.backUrlApi + 'Auth/';

    constructor(
        private http: HttpClient,
        private router: Router
    ) {}

    loginEmployee(cedula: string, fechaNacimiento: any) {
        const body = { usuario: cedula, fechaNacimiento };
        return this.http.post<ILoginEmployee>(this.apiUrl + 'login-employees', body);
    }

    loginCompany(cedula: string, password: string) {
        const body = { usuario: cedula, password };
        return this.http.post<ILoginEmployee>(this.apiUrl + 'login-companies', body);
    }

    challengeQuestions(token: string, questions: IChallengeQuestionsReq) {
        return this.http.post<ResponseModel<IChallengeQuestionsReq>>(this.apiUrl + 'challenge-questions', questions);
    }

    getInfoUser(token: string) {
        return this.http.get<ResponseModel<IDataUser>>(this.apiUrl + 'information');
    }

    refreshToken() {
        return this.http.post<ILoginEmployee>(`${this.apiUrl}refresh-token`, {});
    }

    debugCookies() {
        return this.http.get(`${this.apiUrl}debug-cookies`, {});
    }
}
